module.exports = __webpack_public_path__ + "static/nearman-index-6a5a6d8efe184106a6d7f61f2e441723.png";